/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CasesInputs */

const en_nav_cases = /** @type {(inputs: Nav_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

const pt_br2_nav_cases = /** @type {(inputs: Nav_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos`)
};

/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Nav_CasesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_cases = /** @type {((inputs?: Nav_CasesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CasesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_cases(inputs)
	return pt_br2_nav_cases(inputs)
});